import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;

  box-sizing: border-box;

  border: solid 1px #b1b6bb;
  border-radius: 2px;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;

const Input = styled.input`
  width: 100%;

  border: none;

  padding: 10px 11px;

  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f3133;

  &:focus {
    outline: none;
  }
`;

export default function TextInput({ value, onChange, onSubmit, placeholder, autoFocus, disabled }) {
  return (
    <Wrapper>
      <Input
        disabled={disabled}
        autoFocus={autoFocus}
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onKeyDown={(e) => {
          if (e.code === 'Enter') {
            if (onSubmit) onSubmit(value);
          }
        }}></Input>
    </Wrapper>
  );
}
